export default "__VITE_ASSET__01eeff6c__"